<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">清算调账</span>
    </el-row>
    <el-form class="form-single-inline margin-t20" :inline="true" :model="userForm">
      <el-form-item label="用户名：">
        <el-input style="width:120px;" v-model="userForm.name"></el-input>
      </el-form-item>
      <el-form-item label="密码：">
        <el-input style="width:120px;" v-model="userForm.pass" type="password"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="adjust" @click="customerAssets">客户资产清算</el-button>
        <el-button type="adjust" @click="combinationHold">组合持仓清算</el-button>
        <el-button type="adjust" @click="searchAccountApply">赎回转申认购调账</el-button>
        <el-button type="adjust" @click="combinationOrder">组合下单调账</el-button>
        <el-button type="adjust" @click="couponBuyDetails">使用优惠券购买详情</el-button>
        <el-button type="adjust" @click="calMonthAvgMoney">月度日均存量计算</el-button>
      </el-form-item>
    </el-form>
    <!-- 优惠券购买详情 -->
    <div v-show="couponShow">
      <ul class="adjust-ul clearfix">
        <li>
          <span>使用优惠券总金额：</span>
          <span class="rColor">{{useCouponAmount.totalAmount}}</span>
        </li>
        <li>
          <span>使用优惠券总订单数：</span>
          <span class="rColor">{{useCouponAmount.totalOrders}}</span>
        </li>
        <li>
          <span>使用优惠券失败订单数：</span>
          <span class="rColor">{{useCouponAmount.failedOrders}}</span>
        </li>
      </ul>
      <el-table :data="tableAll" class="table-single">
        <el-table-column label="客户号" prop="code"></el-table-column>
        <el-table-column label="客户姓名" prop="name"></el-table-column>
        <el-table-column label="基金代码" prop="num"></el-table-column>
        <el-table-column label="申请单号" prop="date" width="130"></el-table-column>
        <el-table-column label="申请金额" prop="price"></el-table-column>
        <el-table-column label="实付金额" prop="zq"></el-table-column>
        <el-table-column label="优惠券金额" prop="yhq"></el-table-column>
        <el-table-column label="下单日期" prop="xdate"></el-table-column>
        <el-table-column label="下单时间" prop="xdate"></el-table-column>
        <el-table-column label="交易日期" prop="xdate"></el-table-column>
        <el-table-column label="失败标记">
          <!-- slot-scope="scope" -->
          <template >
            <span class="table-single-btn-normal">成功</span>
          </template>
        </el-table-column>
      </el-table>
      <ul class="adjust-ul clearfix">
        <li>
          <span>当日申请使用优惠券情况</span>
        </li>
      </ul>
      <el-table :data="tableDay" class="table-single">
        <el-table-column label="客户号" prop="code"></el-table-column>
        <el-table-column label="客户姓名" prop="name"></el-table-column>
        <el-table-column label="基金代码" prop="num"></el-table-column>
        <el-table-column label="申请单号" prop="date" width="130"></el-table-column>
        <el-table-column label="申请金额" prop="price"></el-table-column>
        <el-table-column label="实付金额" prop="zq"></el-table-column>
        <el-table-column label="优惠券金额" prop="yhq"></el-table-column>
        <el-table-column label="下单日期" prop="xdate"></el-table-column>
        <el-table-column label="下单时间" prop="xdate"></el-table-column>
        <el-table-column label="交易日期" prop="xdate"></el-table-column>
        <el-table-column label="失败标记">
          <!-- <template slot-scope="scope">
            <span class="table-single-btn-normal">终止</span>
          </template> -->
        </el-table-column>
      </el-table>
      <ul class="adjust-ul clearfix">
        <li>
          <span>当日申请使用优惠券情况(组合)</span>
        </li>
      </ul>
      <el-table :data="tableDayCom" class="table-single">
        <el-table-column label="客户号" prop="code"></el-table-column>
        <el-table-column label="客户姓名" prop="name"></el-table-column>
        <el-table-column label="基金代码" prop="num"></el-table-column>
        <el-table-column label="申请单号" prop="date" width="130"></el-table-column>
        <el-table-column label="申请金额" prop="price"></el-table-column>
        <el-table-column label="实付金额" prop="zq"></el-table-column>
        <el-table-column label="优惠券金额" prop="yhq"></el-table-column>
        <el-table-column label="下单日期" prop="xdate"></el-table-column>
        <el-table-column label="下单时间" prop="xdate"></el-table-column>
        <el-table-column label="交易日期" prop="xdate"></el-table-column>
        <el-table-column label="失败标记">
          <!-- <template slot-scope="scope">
            <span class="table-single-btn-normal">终止</span>
          </template> -->
        </el-table-column>
      </el-table>
    </div>
    <!-- 月度日均存量计算 -->
    <el-table v-show="monthShow" :data="monthTable" class="table-single margin-t20">
      <el-table-column label="客户号" prop="custno"></el-table-column>
      <el-table-column label="客户姓名" prop="custname"></el-table-column>
      <el-table-column label="存量所属月份" prop="statmonth"></el-table-column>
      <el-table-column label="月度存量" prop="monthlystock"></el-table-column>
      <el-table-column label="月度日均存量" prop="dailystock"></el-table-column>
    </el-table>
    <!-- 说明 -->
    <div class="instruction-li">
      <p class="instruction-li-title">1.客户资产清算</p>
      <p class="instruction-li-con">功能：根据基金公司发回来的确认数据进行客户每只基金的持仓和成本清算</p>
      <p class="instruction-li-tip">操作时间：确认数据导入 -> 清算处理 -> 份额对账 -> 产生还款数据 -> 点击【客户资产清算】按钮</p>
    </div>
    <div class="instruction-li">
      <p class="instruction-li-title">2.组合持仓清算</p>
      <p class="instruction-li-con">功能：在确认数据回来之后进行公募基金和精准理财的资产和收益计算</p>
      <p class="instruction-li-tip">操作时间：【客户资产清算】 -> 点击【组合持仓清算】按钮</p>
    </div>
    <div class="instruction-li">
      <p class="instruction-li-title">3.赎回转认申购调账</p>
      <p class="instruction-li-con">功能：对于非货币基金赎回到恒宝宝业务,在赎回基金确认单回来后修改申购基金申请单的上报时间和申购金额</p>
      <p class="instruction-li-tip">操作时间：在完成【清算调账】后，点击【开始】—完成—【清算处理】—【份额对账】—【产生还款数据】，</p>
      <p class="instruction-li-tip">然后点击【赎回转认申购调账】（一般在2.30之前会完成此操作）</p>
      <p class="instruction-li-tip">这个功能需要输入用户名 admin 密码 1q2w3e</p>
    </div>
    <div class="instruction-li">
      <p class="instruction-li-title">4.组合下单调账</p>
      <p class="instruction-li-con">功能：组合申购一次支付需求，在总申请单完成对账后，修改子申请单状态，使其正常上报</p>
      <p class="instruction-li-tip">操作时间：扣款对账后再次登录网页展恒基金网上交易系统首页点击【组合下单调账】-点击组合按钮（一般在15.30之前会完成此操作）</p>
      <p class="instruction-li-con">这个功能需要输入用户名 admin 密码 1q2w3e</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      userForm: {
        name: '',
        pass: '',
      },
      useCouponAmount: {
        totalAmount: '--',
        totalOrders: '--',
        failedOrders: '--',
      },
      tableAll: [],
      tableDay: [],
      tableDayCom: [],
      monthTable: [],
      couponShow: false,
      monthShow: false,
    }
  },
  methods: {
    // 客户资产清算
    customerAssets() {
      this.$http.post(this.$apiPath.liquidation2,{}).then(res => {
        // console.log(res);
        this.$alert(res.data.message, '', {
          confirmButtonText: '确定',
          callback: action => {}
        });
      }).catch(err =>{})
    },
    // 组合持仓清算
    combinationHold() {
      this.$http.post(this.$apiPath.liquidation1,{}).then(res => {
        // console.log(res);
        this.$alert(res.data.message, '', {
          confirmButtonText: '确定',
          callback: action => {}
        });
      }).catch(err =>{})
    },
    // 赎回转申认购调账--------------------------------------------
    searchAccountApply() {
      if(this.userForm.name =="admin" && this.userForm.pass == "1q2w3e") {
        this.$http.post(this.$apiPath.liquidation,{
          id : this.userForm.name,
				  password : this.userForm.pass
        }).then(res => {
          console.log(res);
          let msg = res.data.message + `<br/>`
          let showInfo = res.data.data.showInfo
          if(showInfo.length > 0){
            msg = msg + "共"+showInfo.length+"条赎回转申购购买确认失败的记录，需要柜台手动为客户申购恒宝宝！！！！<br/>"
            for(let i=0;i<showInfo.length;i++){
              msg = msg + "客户名 : "+showInfo[i].custfullname+",确认金额 : "+showInfo[i].confirmedamount + `<br/>`
            }
          }
          this.$alert(msg, '', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            callback: action => {}
          });
        }).catch(err =>{})
      } else {
        this.$message.error('用户名密码不正确')
      }
    },
    // 组合下单调账
    combinationOrder() {
      this.$http.post(this.$apiPath.liquidation3,{
        id : this.userForm.name,
				password : this.userForm.pass
      }).then(res => {
        // console.log(res);
        this.$alert(res.data.message, '', {
          confirmButtonText: '确定',
          callback: action => {}
        });
      }).catch(err =>{})
    },
    // 使用优惠券购买详情
    couponBuyDetails() {
      this.$http.post(this.$apiPath.searchyhqlist,{}).then(res => {
        // console.log(res);
        this.couponShow = true
        if(res.data.code == 200) {
          let amount = res.data.data.list1[0]
          this.useCouponAmount = {
            totalAmount: amount.totalticketamount,
            totalOrders: amount.totalordercount,
            failedOrders: amount.failedordercount,
          }
          this.tableAll = res.data.data.publicRecord
          this.tableDay = res.data.data.list3
          this.tableDayCom = res.data.data.list4
        }
      }).catch(err =>{})
    },
    // 月度日均存量计算
    calMonthAvgMoney() {
      this.$http.post(this.$apiPath.searchAvgMoney,{}).then(res => {
        // console.log(res);
        this.monthShow = true
        if(res.data.code == 200) {
          this.monthTable = res.data.data.publicRecord
        } else {
          this.$alert(res.data.message, '', {
            confirmButtonText: '确定',
            callback: action => {}
          });
        }
      }).catch(err =>{})
    },
  }
}
</script>

<style lang="less" >
.el-button--adjust:focus,
.el-button--adjust:hover {
  border-color: @color;
  background-color: @wColor;
  color: @color;
}
.el-button--adjust {
  padding: 8px;
  border-color: @color;
  background-color: @wColor;
  font-size: 12px;
  color: @color;
}
.adjust-ul {
  margin: 20px 0;
  li {
    padding-right: 20px;
    float: left;
    font-size: 18px;
  }
}
</style>